import type { SVGProps } from "react";

export function IconUmbrella(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="56" height="56" rx="28" fill="#FAF4F0" />
      <path
        d="M28 28V36"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="square"
      />
      <path
        d="M28 36.6667C28 37.192 28.1035 37.7122 28.3045 38.1975C28.5055 38.6828 28.8001 39.1237 29.1716 39.4952C29.543 39.8666 29.984 40.1612 30.4693 40.3623C30.9546 40.5633 31.4747 40.6667 32 40.6667C32.5253 40.6667 33.0454 40.5633 33.5307 40.3623C34.016 40.1612 34.457 39.8666 34.8284 39.4952C35.1999 39.1237 35.4945 38.6828 35.6955 38.1975C35.8965 37.7122 36 37.192 36 36.6667"
        stroke="black"
        strokeWidth="2"
      />
      <mask
        id="mask0_2665_13360"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="15"
        y="15"
        width="26"
        height="14"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M40 28C40 21.3726 34.6274 16 28 16C21.3726 16 16 21.3726 16 28H40Z"
          fill="#F9832F"
        />
        <path
          d="M40 28V29H41V28H40ZM16 28H15V29H16V28ZM28 17C34.0751 17 39 21.9249 39 28H41C41 20.8203 35.1797 15 28 15V17ZM17 28C17 21.9249 21.9249 17 28 17V15C20.8203 15 15 20.8203 15 28H17ZM16 29H40V27H16V29Z"
          fill="#F9832F"
        />
      </mask>
      <g mask="url(#mask0_2665_13360)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M40 28C40 21.3726 34.6274 16 28 16C21.3726 16 16 21.3726 16 28H40Z"
          fill="#F9832F"
        />
        <path
          d="M40 28V29H41V28H40ZM16 28H15V29H16V28ZM28 17C34.0751 17 39 21.9249 39 28H41C41 20.8203 35.1797 15 28 15V17ZM17 28C17 21.9249 21.9249 17 28 17V15C20.8203 15 15 20.8203 15 28H17ZM16 29H40V27H16V29Z"
          fill="#F9832F"
        />
        <path
          d="M34 28C34 24.287 33.3679 20.726 32.2426 18.1005C31.1174 15.475 29.5913 14 28 14C26.4087 14 24.8826 15.475 23.7574 18.1005C22.6321 20.726 22 24.287 22 28"
          stroke="black"
          strokeWidth="2"
          strokeLinecap="square"
        />
      </g>
    </svg>
  );
}
